import React from 'react';
import { Scenario, ScenarioType } from '../../types/app';
import { ScenarioCard } from './ScenarioCard';
// import { AddScenarioButton } from './AddScenarioButton';

interface ScenarioCarouselProps {
  scenarios: Scenario[];
  activeScenarioId: string | null;
  onSelectScenario: (scenarioId: string) => void;
  onAddScenario: (scenarioType: ScenarioType) => void;
  onRemoveScenario: (scenarioId: string) => void;
  onUpdateScenarioTitle: (scenarioId: string, title: string) => void;
  onUpdateScenarioLink: (scenarioId: string, link?: string) => void;
  onToggleVisibility: (scenarioId: string) => void;
  onToggleBaseline: (scenarioId: string) => void;
  canAddScenario: boolean;
  globalOrder?: string[];
}

export const ScenarioCarousel: React.FC<ScenarioCarouselProps> = ({
  scenarios,
  activeScenarioId,
  onSelectScenario,
  onAddScenario,
  onRemoveScenario,
  onUpdateScenarioTitle,
  onUpdateScenarioLink,
  onToggleVisibility,
  onToggleBaseline,
  canAddScenario,
  globalOrder,
}) => {
  const handleRemoveScenario = (scenarioId: string) => {
    // Allow removing all scenarios
    onRemoveScenario(scenarioId);
  };

  return (
    <div className="relative h-full">
      {scenarios.length === 0 ? (
        <div className="h-full flex items-center justify-center text-gray-500">
          <div className="text-center">
            <p className="text-sm">No scenarios yet</p>
            <p className="text-xs mt-1">Click "New Scenario" to get started</p>
          </div>
        </div>
      ) : (
        <div className="h-full overflow-y-auto">
          <div className="space-y-3 pr-1">
            {scenarios.map((scenario, idx) => {
              const globalIdx = globalOrder ? globalOrder.indexOf(scenario.id) : idx;
              return (
                <div key={scenario.id} className="group">
                  <ScenarioCard
                    scenario={scenario}
                    isActive={scenario.id === activeScenarioId}
                    onSelect={() => onSelectScenario(scenario.id)}
                    onRemove={() => handleRemoveScenario(scenario.id)}
                    onTitleChange={(title) => onUpdateScenarioTitle(scenario.id, title)}
                    onLinkChange={(link) => onUpdateScenarioLink(scenario.id, link)}
                    onToggleVisibility={() => onToggleVisibility(scenario.id)}
                    onToggleBaseline={() => onToggleBaseline(scenario.id)}
                    colorIndex={globalIdx >= 0 ? globalIdx : idx}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
